import { createReducer, on } from "@ngrx/store";
import { Client } from "../../models/client";
import { Decorator } from "../../models/decorator";
import { getAllUserClientsSuccess, getAllUserClientsFailure, getAllUserDecoratorsFailure, getAllUserDecoratorsSuccess, getAllAffiliateDecoratorsSuccess, getAllAffiliateDecoratorsFailure, searchUserClients, searchUserClientsSuccess, searchUserClientsFailure, clearSearchClients } from "./user.actions";
import { User } from "@auth0/auth0-angular";

export const featureName = "user";

export interface State {
    decorators?: [Decorator],
    clients?:[Client],
    searchedClients?: Client[],
    searchLoading?: boolean,
    searchTotal?: number,
    searchTotalAvailable?: number,
    searchPage?: number,
    searchLimit?: number,
    searchTotalPages?: number,
    userError?: string,
    decoratorError?:string,
    clientError?:string,
    clientContextError?: string
}

export const initialState: State = {
    decorators: null,
    clients: null,
    searchedClients: null,
    searchLoading: false,
    searchTotal: 0,
    searchTotalAvailable: 0,
    searchPage: 1,
    searchLimit: 6,
    searchTotalPages: 0,
}

const _userReducer = createReducer(
    initialState,
    on(getAllUserClientsSuccess, (state, {userClients}) => {
        return {
            ...state,
            clients: userClients.data
        }
    }),
    on(getAllUserClientsFailure, (state, {error}) => {
        console.error(error)
        return {
            ...state,
            clients: null,
            clientError: error
        }
    }),
    on(getAllAffiliateDecoratorsSuccess, (state, {affiliateDecorators}) => {
        return {
            ...state,
            decorators: affiliateDecorators.data
        }
    }),
    on(getAllAffiliateDecoratorsFailure, (state, {error}) => {
        return {
            ...state,
            decorators: null,
            decoratorError: error
        }
    }),
    on(getAllUserDecoratorsSuccess, (state, {userDecorators}) => {
        return {
            ...state,
            decorators: userDecorators.data
        }
    }),
    on(getAllUserDecoratorsFailure, (state, {error}) => {
        return {
            ...state,
            decorators: null,
            decoratorError: error
        }
    }),
    on(searchUserClients, (state) => {
        return {
            ...state,
            searchLoading: true
        }
    }),
    on(searchUserClientsSuccess, (state, { results, total, totalAvailable, page, limit, totalPages }) => {
        return {
            ...state,
            searchedClients: results as any,
            searchLoading: false,
            searchTotal: total,
            searchTotalAvailable: totalAvailable,
            searchPage: page,
            searchLimit: limit,
            searchTotalPages: totalPages
        }
    }),
    on(searchUserClientsFailure, (state, {error}) => {
        return {
            ...state,
            searchedClients: null,
            searchLoading: false,
            clientError: error
        }
    }),
    on(clearSearchClients, (state) => {
        return {
            ...state,
            searchedClients: null,
            searchLoading: false,
            searchTotal: 0,
            searchPage: 1,
            searchTotalPages: 0
        }
    })
)

export function userReducer(state, action){
    return _userReducer(state, action)
}
